import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'
const Alert = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, diagnosisName, setPatientDBdata, noteID }) => {
    console.log(diagnosisName, 'diagnosisName here')

    const [textValue, setTextValue] = useState("")
    const [modalText, setModalText] = useState("")

    useEffect(() => {
        const alertText = patientDBdata?.currentNote?.data?.alertData?.[diagnosisName] || ""
        console.log(alertText, 'alertText for', diagnosisName)
        setModalText(alertText)
        setTextValue(alertText)
    }, [])

    if (!textValue) {
        return
    }

    const handleBlur = () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        alertData: {
                            ...prev?.currentNote?.data?.alertData,
                            [diagnosisName]: modalText,
                        },
                    },
                },
                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteID) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}
                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                alertData: {
                                    ...parsedData?.alertData,
                                    [diagnosisName]: modalText,
                                },
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }

    return (
        <div className='w-100'>
            <div>Alert</div>
            <div className='d-flex flex-column gap-3 w-100'>
                <GraytextareaAdjustable
                    onBlur={handleBlur}
                    onChange={(e) => {
                        setModalText(e.target.value)
                    }}
                    height={"100px"}
                    value={modalText}
                />
            </div>
        </div>
    )
}

export default Alert